import { fetch } from '../services/fetch'
import { routes } from '../config'

export const getProfile = payload => fetch.post(routes.getProfile, payload)

export const saveProfile = (user, payload) => fetch.post(routes.saveProfile, user, payload)
